exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".school-info-page{min-height:100vh;background-color:#f5f7f7;display:flex;flex-direction:column;padding-bottom:80px}.school-info-page__top-bar{z-index:1;margin-bottom:40px}.school-info-page__title{font-size:24px;line-height:48px;font-weight:700;font-size:32px;text-align:center}.school-info-page__subtitle{font-size:20px;line-height:32px;font-weight:400;text-align:center;margin-bottom:40px}.school-info-page__school-licence-card-container{display:flex;justify-content:center;align-items:center}", ""]);
// Exports
exports.locals = {
	"medium": "768px",
	"large": "1024px",
	"xlarge": "1440px"
};